/**
 * CaptureButton Component
 * Button to capture current camera frame to an image slot
 * 
 * Requirements: 1.2, 1.3, 1.4
 */

import './CaptureButton.css';

export interface CaptureButtonProps {
  disabled: boolean;
  onClick: () => void;
  className?: string;
}

function CaptureButton({ disabled, onClick, className }: CaptureButtonProps) {
  return (
    <button
      className={`capture-button ${className || ''}`}
      onClick={onClick}
      disabled={disabled}
      aria-label="Capture image"
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" />
        <circle cx="12" cy="13" r="4" />
      </svg>
      <span>Capture</span>
    </button>
  );
}

export default CaptureButton;
